import { GasNetworkTariffModel, GasStationModel, TrailerModel } from '@core/api';
import { UserModel } from '@core/api/model/userModel';
import { TransportModel } from '@core/api/model/transportModel';

export interface OrderModel {
  id?: number;
  user_id: number;
  gas_station_id: number;
  trailer_id: number;
  transport_id: number;
  tariff_id: number;
  rent_hours: number;
  status?: OrderModel.StatusEnum;
  tariff_type?: GasNetworkTariffModel.TypeEnum;
  tariff_cost?: number;
  tariff_overpay_cost?: number;
  return_price_to_another_point?: number;
  tariff_min_rent_hours?: number;
  cost?: number;
  ordered_to?: string;
  created_at?: string;
  expired_at?: number;
  has_transfer_act: boolean;
  has_return_act: boolean;
  adapter_passed?: boolean;
  adapter_returned?: boolean;
  rent_started_at?: string;
  network?: {
    [key: string]: string | number;
  } | null;

  trailer?: TrailerModel;
  transport?: TransportModel;
  gasStation?: GasStationModel;
  returnGasStation?: GasStationModel;
  user?: UserModel;

  returnDamages?: any;
  actions?: any;

  extraCost?: number;
  extraHours?: number;
  return_gas_station_id?: number;
  tariff?: GasNetworkTariffModel;
}

export namespace OrderModel {
  export type StatusEnum = 'created' | 'verified' | 'paid' | 'closed' | 'rejected' | 'in_rent' | 'acceptance';
  export const StatusEnum = {
    Created: 'created' as StatusEnum,
    Verified: 'verified' as StatusEnum,
    Paid: 'paid' as StatusEnum,
    Closed: 'closed' as StatusEnum,
    Rejected: 'rejected' as StatusEnum,
    InRent: 'in_rent' as StatusEnum,
    Transferred: 'transferred' as StatusEnum,
    Acceptance: 'acceptance' as StatusEnum
  };
}
